import { colors } from '../colors.js';
import { radii } from '../radius.js';
import { space } from '../spacing.js';
import { sizes } from '../sizing.js';
import { paragraphs } from './paragraphs.js';
export const basePill = {
    borderRadius: radii.x3,
    paddingLeft: space.x2,
    paddingRight: space.x2,
};
export const pillTypography = {
    ...paragraphs.smallCompact,
    lineHeight: 's',
};
export const pillVariants = {
    neutral: {
        backgroundColor: colors.backgrounds.secondaryOnGray,
        color: colors.text.default,
    },
    warning: {
        backgroundColor: colors.backgrounds.warning,
        color: colors.text.warning,
    },
    error: {
        backgroundColor: colors.backgrounds.error,
        color: colors.text.error,
    },
    accent: {
        backgroundColor: colors.backgrounds.accent,
        color: colors.text.primary,
    },
    success: {
        backgroundColor: colors.backgrounds.success,
        color: colors.text.success,
    },
};
export const pillLoading = {
    backgroundColor: colors.backgrounds.secondaryOnGray,
    color: 'transparent',
    height: sizes.x5,
};
//# sourceMappingURL=pills.js.map